import React from 'react';

const StaticIconLabel = ({
  label = '',
  icon = false,
}) => {
  return (
    <span className='flex items-center'>
      {label && <span>{label}</span>}
      {icon && (
        <span
          aria-hidden={true}
          className={icon.classes}
          dangerouslySetInnerHTML={{ __html: icon.svg }}
        />
      )}
    </span>
  );
};

export default StaticIconLabel;
